import React from 'react';
export function WhatsInside() {
  const contents = [{
    title: '🌙 Semana 1: Resetea tu Ritmo',
    desc: 'Aprende a sincronizar tu reloj biológico con luz solar, horarios consistentes y rituales nocturnos.'
  }, {
    title: '🧠 El Protocolo del Cortisol Nocturno',
    desc: 'Las 5 técnicas que bajan el cortisol antes de dormir — respaldadas por la ciencia.'
  }, {
    title: '📴 La Regla de las Pantallas',
    desc: 'El método exacto para desconectarte de la tecnología sin sentir que te pierdes de algo.'
  }, {
    title: '🍵 Alimentación para el Sueño',
    desc: 'Los 7 alimentos que promueven la melatonina y los que la destruyen sin que lo sepas.'
  }, {
    title: '🌬️ Respiración para Dormir',
    desc: '3 técnicas de respiración que activan el sistema nervioso parasimpático en minutos.'
  }, {
    title: '🏆 Semana 2: Consolida y Transforma',
    desc: 'Optimiza tu ambiente de sueño, tus conexiones emocionales y tu plan de mantenimiento permanente.'
  }];
  return <section className="bg-cream py-20" data-id="element-145">
      <div className="max-w-6xl mx-auto px-4" data-id="element-146">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-text text-center mb-12" data-id="element-147">
          ¿Qué encontrarás en esta guía?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-148">
          {contents.map((item, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1" data-id="element-149">
              <h3 className="font-serif text-xl font-bold text-primary mb-3" data-id="element-150">
                {item.title}
              </h3>
              <p className="text-gray leading-relaxed" data-id="element-151">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}